import type { ReactNode } from 'react';
import type { PageExperience } from '@/features/experiences/types';
import { getStyleById } from '../../../theme';

type Props = {
  experience: PageExperience;
  children: ReactNode;
  monthKey?: string;
};

export const HeaderRow = ({ experience, children, monthKey }: Props) => {
  const theme = getStyleById(experience.styleId ?? undefined);

  return (
    <div
      data-measure={monthKey ? `header-row-${monthKey}` : undefined}
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
        backgroundColor: theme.accentColor || '#F0F0F0',
        borderBottom: `2px solid ${theme.accentColor || '#000000'}`,
      }}
    >
      {children}
    </div>
  );
};
